import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';
import { BusinessCardAttachments } from 'src/types';

import { fetchDocumentsFromCollection } from './utils/fetchDocumentsFromCollection';

export const useGetBusinessCardAttachmentsFromFirebase = (
  hotelId: string,
  businessCardId: string,
  options?: UseQueryOptions<BusinessCardAttachments[], FirebaseError>,
): UseQueryResult<BusinessCardAttachments[], FirebaseError> => useQuery<BusinessCardAttachments[], FirebaseError>({
  queryKey: [`hotels/${hotelId}/businessCards/${businessCardId}/attachments`],
  queryFn: async (): Promise<BusinessCardAttachments[]> => {
    const collectionPath = `hotels/${hotelId}/businessCards/${businessCardId}/attachments`;
    const data = await fetchDocumentsFromCollection<BusinessCardAttachments>(collectionPath);
    return data.map((item) => ({
      id: item?.id,
      fileUrl: item?.fileUrl,
      name: item?.name,
      custom_file: item?.custom_file,
    }));
  },
  retry: 1,
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
  ...options,
});
